import { render, staticRenderFns } from "./DemandesItem.vue?vue&type=template&id=f0852484&"
import script from "./DemandesItem.vue?vue&type=script&lang=js&"
export * from "./DemandesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports